import { __read, __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import clsx from 'clsx';
import { Card } from '../../../base/card/Card.js';
import styles from './Body.module.scss.js';

var Body = function (_a) {
    var _b;
    var _c = _a.disableToggleDetailsOnMobile, disableToggleDetailsOnMobile = _c === void 0 ? false : _c, children = _a.children;
    var _d = __read(useState(disableToggleDetailsOnMobile), 2), detailsVisible = _d[0], setDetailsVisible = _d[1];
    return (jsxs(Fragment, { children: [jsx("div", __assign({ className: clsx(styles.content, (_b = {}, _b[styles.showContent] = detailsVisible, _b)) }, { children: children })), detailsVisible && !disableToggleDetailsOnMobile && jsx(Card.Separator, { isFullWidth: true, className: styles.separator }), !disableToggleDetailsOnMobile && (jsx("button", __assign({ className: styles.viewDetails, onClick: function () { return setDetailsVisible(function (v) { return !v; }); } }, { children: detailsVisible ? 'Hide Details' : 'View Details' })))] }));
};

export { Body };
